import { GET_APOB_SELLER_REQUEST, GET_APOB_SELLER_SUCCESS, GET_APOB_SELLER_FAILED } from '../types';

import { combineReducers } from 'redux';

const IntialState = {
  loading: false,
  status: null,
  message: null,
  apobSellerList: [],
  isError: false,
};

const apobSellerList = (state = IntialState, action) => {
  const { type, response: res, message } = action;
  switch (type) {
    case GET_APOB_SELLER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_APOB_SELLER_SUCCESS:
      return {
        ...state,
        status: res.status,
        apobSellerList: res.data,
        loading: false,
        isError: false,
      };
    case GET_APOB_SELLER_FAILED:
      return {
        ...state,
        message,
        loading: false,
        isError: true,
      };
    default:
      return state;
  }
};

const apobSeller = combineReducers({
  apobSellerList,
});
export default apobSeller;
